import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 256",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 256,
			height: 256,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 216,
			y1: 128,
			x2: 40,
			y2: 128,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "112 56 40 128 112 200",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		})
	]
});
export default SvgArrowLeft;
